import React, { useEffect, useState } from "react";
import axios from "../../api/axios";
import {
  Grid,
  Paper,
  Typography,
  TextField,
  MenuItem,
  Snackbar,
  CircularProgress,
  Divider,
  Box,
} from "@mui/material";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";

function StaffDetails() {
  const [pfno, setPfno] = useState("");
  const [designationList, setDesignationList] = useState([]);
  const [designationId, setDesignationId] = useState("");
  const [staffDetails, setStaffDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "" });

  useEffect(() => {
    if (pfno.length >= 5) {
      axios
        .get(`/staff/designations/${pfno}`)
        .then((res) => setDesignationList(res.data))
        .catch(() => {
          setDesignationList([]);
          setSnackbar({ open: true, message: "Failed to load designations" });
        });
    } else {
      setDesignationList([]);
      setDesignationId("");
    }
  }, [pfno]);

  useEffect(() => {
    if (pfno && designationId) {
      fetchStaffDetails();
    }
  }, [designationId]);

  const fetchStaffDetails = async () => {
    setLoading(true);
    try {
      const res = await axios.post("/staff/details", {
        pfno,
        designation_id: designationId,
      });
      setStaffDetails(res.data);
    } catch (err) {
      setStaffDetails(null);
      setSnackbar({ open: true, message: "Staff not found or error occurred" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox py={3}>
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            borderRadius: 4,
            background: "#fdfdfd",
            boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
          }}
        >
          <Typography variant="h4" gutterBottom color="primary">
            Staff Payslip View
          </Typography>

          <Grid container spacing={3} mb={3}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="PFNO"
                value={pfno}
                onChange={(e) => setPfno(e.target.value)}
                variant="outlined"
                placeholder="Enter staff PFNO"
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                select
                label="Designation"
                value={designationId}
                onChange={(e) => setDesignationId(e.target.value)}
                variant="outlined"
                placeholder="Select Designation"
              >
                <MenuItem value="">
                  <em>-- Select Designation --</em>
                </MenuItem>
                {designationList.map((d) => (
                  <MenuItem key={d.id} value={d.id}>
                    {d.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>

          {loading && (
            <MDBox textAlign="center" mt={3}>
              <CircularProgress />
            </MDBox>
          )}

          {staffDetails && (
            <Paper
              elevation={1}
              sx={{
                mt: 4,
                p: 4,
                borderRadius: 3,
                background: "#fff",
                border: "1px solid #eee",
              }}
            >
              <Typography variant="h5" align="center" gutterBottom>
                Staff Payslip
              </Typography>
              <Divider sx={{ mb: 2 }} />

              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body1">
                    <strong>Name:</strong>{" "}
                    {`${staffDetails.surname} ${staffDetails.firstname} ${staffDetails.othername}`}
                  </Typography>
                  <Typography variant="body1">
                    <strong>PFNO:</strong> {staffDetails.pfno}
                  </Typography>
                  <Typography variant="body1">
                    <strong>Cadre:</strong> {staffDetails.cadre_name}
                  </Typography>
                  <Typography variant="body1">
                    <strong>Grade Level:</strong> {staffDetails.grade_level}
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography variant="body1">
                    <strong>Designation:</strong>{" "}
                    {designationList.find((d) => d.id === parseInt(designationId))?.name || "N/A"}
                  </Typography>
                  <Typography variant="body1">
                    <strong>Salary Structure:</strong> {staffDetails.salary_structure}
                  </Typography>
                  <Typography variant="body1">
                    <strong>Staff Group:</strong> {staffDetails.staff_group}
                  </Typography>
                  <Typography variant="body1">
                    <strong>Monthly Salary:</strong>{" "}
                    {staffDetails.amount && !isNaN(staffDetails.amount)
                      ? (Number(staffDetails.amount) / 12).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      : "0.00"}
                  </Typography>
                </Grid>
              </Grid>

              <Divider sx={{ my: 2 }} />
              <Box textAlign="center">
                <Typography variant="caption" color="text.secondary">
                  This slip is auto-generated and confidential.
                </Typography>
              </Box>
            </Paper>
          )}
        </Paper>
      </MDBox>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ open: false, message: "" })}
        message={snackbar.message}
      />

      <Footer />
    </DashboardLayout>
  );
}

export default StaffDetails;
